import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import OnboardingProgressSidebar from '@/components/navigation/OnboardingProgressSidebar';
import { useOnboarding } from './OnboardingContext';
import './onboarding.css';

const STEP_LABELS: Record<string, string> = {
    'password': 'Vos accès',
    'facility': 'Votre établissement',
    'branding-logo': 'Votre logo',
    'branding-colors': 'Vos couleurs',
    'branding-fonts': 'Polices & boutons',
    'users': 'Votre équipe',
    'recap': 'Bienvenue',
};

const OPTIONAL_STEPS = new Set([
    'pms',
    'branding-logo',
    'branding-colors',
    'branding-fonts',
    'users',
    'first-flows',
]);

export default function OnboardingLayout({ children }: { children: ReactNode }) {
    const { t } = useTranslation('onboarding');
    const { steps, currentStep, currentIndex, goToStep } = useOnboarding();
    const completedSlugs = steps.slice(0, currentIndex);

    const stepDefs = steps.map((slug) => ({
        slug,
        // Libellé traduit pour les étapes récentes ; les autres gardent STEP_LABELS.
        label: slug === 'first-flows'
            ? t('quickStart.sidebar_label')
            : slug === 'pms'
                ? t('pms.sidebar_label')
                : (STEP_LABELS[slug] ?? slug),
        optional: OPTIONAL_STEPS.has(slug),
    }));

    return (
        <div className="onboarding-wizard">
            <OnboardingProgressSidebar
                steps={stepDefs}
                currentStepSlug={currentStep}
                completedSlugs={completedSlugs}
                onStepClick={(slug) => goToStep(slug as any)}
            />
            <main className="onboarding-wizard__main">
                <div className="onboarding-wizard__container">{children}</div>
            </main>
        </div>
    );
}
